

export default function DataScience(){
    return (
        <section>
        <div className="Card">
            <h3>NumPy - Numerical Python</h3>
            <p>Open source Python library that is fast and efficient in
                performing mathematical operations.
                Being written in C programming language it's
                execution time is very low. Because it facilitates operations
                on multi-dimensional arrays and matrices it is commonly applied in
                science and engineering. Arbitrary data types can be defined using NumPy
                and integration with a wide variety of databases is also supported.<br/>
                numpy.ndarray()<br/>
                numpy.zeros() <br/>
                numpy.ones() <br/>
                numpy.empty() <br/>
                numpy.arange() <br/>
                numpy.reshape() <br/>
                numpy.linspace() <br/>
                
            </p>
        </div>
        <div className="Card">
            <h3>ndarray - NumPy Array</h3>
            <p></p>
        </div>
        <div className="Card">
            <h3>ndarray - Useful Attributes</h3>
            <p>ndarray.ndim - array's number of dimensions<br/> 
                ndarray.shape - tuple of integers that represents the size 
                of the array in each dimension<br/>
                
            </p>
        </div>
        </section>
    )
}